import {
  BaseFormViewModel,
} from '../../types';
import { EventDTO } from './eventDTO';

export enum EventType {
  RENEWAL = "RENEWAL",
  WIFI_PACKAGE = "WIFI_PACKAGE",
  LEAD = "LEAD",
}

export class EventFormViewModel extends BaseFormViewModel<EventDTO> {
  eventId: number;
  title: string;
  startTime: Date;
  endTime: Date;
  excepctedUserNumbers: number;
  earlyComersEdge: number;
  isActive: boolean;
  type: EventType [];
  eventGroupId?: number [];

  constructor(dto: EventDTO) {
    super();
    const {
      title,
      earlyComersEdge,
      endTime,
      excepctedUserNumbers,
      isActive,
      startTime,
      eventId,
      type,
      eventGroupId
    } = dto;
    Object.assign(this, {
      title,
      earlyComersEdge,
      endTime,
      excepctedUserNumbers,
      isActive,
      startTime,
      eventId,
      type: [type],
      eventGroupId: eventGroupId ? [eventGroupId] : [] 
    });
  }

  toDTO() {
    return {} as EventDTO;
  }
}
